import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	name: ForNodeType<string>;
	onSetName: (input: string) => void;

	title?: string;
	guide?: string;
};

export const QuestionOptionName = ({ name, onSetName, title: _title, guide: _guide }: Props) => {
	const title = _title ?? "オプション名";
	const guide =
		_guide ?? "他のオプションとの違いがわかりやすい名前にしましょう。日本語の場合30文字まで入力ができます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={true}
			title={title}
			guide={guide}
			isEdited={name.isEdited}
			hasError={Boolean(name.error)}
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onSetName} />}
		/>
	);
};
